import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function Footer() {
    const { t } = useI18n();
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-white/10 bg-[#050505] mt-24"
        >
            <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
                    <div className="col-span-2">
                        <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-3">
                            {t("footer.streetwear_morocco")}
                        </p>
                        <p className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tighter leading-none">
                            {t("footer.tagline_1")}<br />
                            {t("footer.tagline_2")}
                        </p>
                        <p className="mt-6 text-sm text-white/60 max-w-sm leading-relaxed">
                            {t("footer.brand_desc")}
                        </p>
                    </div>

                    <div>
                        <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">
                            {t("footer.shop")}
                        </p>
                        <ul className="flex flex-col gap-3 text-sm">
                            <li>
                                <Link to="/collection" className="link-underline text-white/80 hover:text-white">
                                    {t("footer.all_products")}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/collection?category=tshirt"
                                    className="link-underline text-white/80 hover:text-white"
                                >
                                    {t("nav.tshirts")}
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/collection?category=cap"
                                    className="link-underline text-white/80 hover:text-white"
                                >
                                    {t("nav.caps")}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">
                            {t("footer.info")}
                        </p>
                        <ul className="flex flex-col gap-3 text-sm text-white/80">
                            <li>{t("footer.cod")}</li>
                            <li>{t("footer.delivery")}</li>
                            <li>{t("footer.returns_7")}</li>
                            <li className="pt-3">
                                <a
                                    href="https://instagram.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="inline-flex items-center gap-2 link-underline"
                                    data-testid="social-instagram"
                                >
                                    <Instagram size={16} strokeWidth={1.5} /> {t("footer.instagram")}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 overflow-hidden">
                    <p className="font-display text-[16vw] leading-none font-black uppercase tracking-tighter text-white/[0.04] select-none whitespace-nowrap">
                        MAKE RIZK
                    </p>
                </div>

                <div className="mt-8 flex flex-col sm:flex-row justify-between gap-3 text-xs uppercase tracking-[0.2em] text-white/40">
                    <p>© {new Date().getFullYear()} Make Rizk. {t("footer.rights")}</p>
                    <p>{t("footer.location")}</p>
                </div>
            </div>
        </footer>
    );
}
